import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import LawFirmForm from '@/modules/law_firm/components/LawFirmForm.vue';
import { LawFirm, useLawFirm } from '@/modules/law_firm/LawFirm';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'LawFirmEdit',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { $gettext } = useGettext();
const lawFirm = ref<LawFirm | null>(null);

const load = async () => {
	try {
		const response = await useLawFirm().get(route.params.id as string);
		if (response) {
			lawFirm.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'law_firm.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	lawFirm.value = u;
	Flash.success($gettext('Externa partnern har sparats.'));
};

const cancel = () => {
	router.push({ name: 'law_firm.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LawFirmForm, {
    "page-title": _unref($gettext)('Redigera extern partner'),
    "law-firm": lawFirm.value,
    onSaved: saved,
    onCancel: cancel,
    "for-create": false
  }, null, 8, ["page-title", "law-firm"]))
}
}

})